import React from 'react';
import { FormGroup, AddressForm } from 'components/common/Forms';
import { compose } from 'recompose';
import { Control, actions } from 'react-redux-form';
import { Card, CardBody, Row, Col } from 'reactstrap';

export const InstallerDetails = ({
  item,
  renderServerError,
  dispatch,
  readOnly,
}) => (
  <div>
    <FormGroup label="Contact Name *" model=".contact_name">
      <Control.text
        updateOn="blur"
        model=".contact_name"
        required
        disabled={readOnly}
      />
    </FormGroup>
    <FormGroup label="Contact Number *" model=".contact_phone">
      <Control.text
        updateOn="blur"
        type="tel"
        model=".contact_phone"
        required
      />
    </FormGroup>
    <Row>
      <Col xs="12" sm="12" md="12" lg="6" xl="6">
        <FormGroup label="Contact Address">
          <Card>
            <CardBody>
              <AddressForm
                model=".contact_address"
                renderServerError={renderServerError}
              />
              {renderServerError('contact_address')}
            </CardBody>
          </Card>
        </FormGroup>
      </Col>
      <Col xs="12" sm="12" md="12" lg="6" xl="6">
        <FormGroup label="Billing Address">
          <Card>
            <CardBody>
              <FormGroup
                label="Billing Address same as Contact Address"
                check
                disabled={readOnly}
              >
                <Control.checkbox
                  model=".billing_address_same"
                  changeAction={(model, value) => {
                    dispatch(actions.change(model, value));
                    setTimeout(() => {
                      dispatch(actions.validate('local.billing_address'));
                    }, 0);
                  }}
                />
              </FormGroup>
              {!item.billing_address_same && (
                <AddressForm
                  model=".billing_address"
                  renderServerError={renderServerError}
                />
              )}
              {renderServerError('billing_address')}
            </CardBody>
          </Card>
        </FormGroup>
      </Col>
    </Row>
  </div>
);

const enhance = compose();

export default enhance(InstallerDetails);



// WEBPACK FOOTER //
// ./src/pages/Installers/InstallerDetails.jsx